export const getMessage = state => state.general && state.general.message;
export const getStates = state => state.general && state.general.states;
export const getAppConfig = state => state.general && state.general.appConfig;
export const getAppTheme = state => state.general && state.general.theme;
export const getLang = state => state?.general?.appConfig?.lang;
export const getUserInput = state => state?.general?.userInput;
export const getInputHistory = state => state?.general?.inputHistory;
export const getGlobalSearchHistory = state =>
  state?.general?.userInput?.globalSearch;
